module.exports = __webpack_public_path__ + "static/media/silver-cup-icon.a5ac062d.svg";